<template>
  <div class="referred">
    <v-card-text>

      <div class="req-list req-all-attach">
        <div class="req-card"  v-for="item in attach_items" :key="item.Id">
          <div>
            <div class="flex-no-wrap justify-space-between">
              <div>
                <div
                  class="req-name"
                  v-text="item.RequestName"
                ></div>

                <span class="req-code">{{ $t('imageName') }}<span class="bold">
                    {{ item.ImageName }}
                    </span>
                  </span>

                <div>

                  <div class="address">
                    <a :href="item.ImagePath" target="_blank">
                    <img height="100px" :src="item.ImagePath"/>
                    </a>
                  </div>

                </div>
              </div>

            </div>

          </div>

        </div>

      </div>

    </v-card-text>
  </div>

</template>
<script>

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        selected_branch: 0,
        attach_items: [],
        show_loading: false,
        page: 0,

        first: true,
      }
    },
    components: {

    },
    watch: {

    },
    mounted () {
      this.get_attachs()
    },

    methods: {
      goToDetail (item) {
        // var passing_data = JSON.parse(localStorage.getItem('request_data'));
        // passing_data.cat_id = item_id;
        // localStorage.setItem("request_data",JSON.stringify(passing_data));
        if (item.IsFinalize == 1) {
          this.$router.push({ name: 'ViewRequest', params: { rec_id: item.Id } })
        } else {
          this.$router.push({ name: 'ViewPreRequest', params: { rec_id: item.Id } })
        }
      },
      get_attachs () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          IsFinalize: 1,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetUserRequestImages', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
             self.attach_items = response.data.results
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
